export const ELECTION_ATTRIBUTE_NUMBERS = {
    active: 'active',
    election_start_date: 'election_start_date',
    election_end_date: 'election_end_date',
    election_next_year: 'election_next_year',
    election_candidate_elimination: 'election_candidate_elimination',
    election_number_of_alt_candidates: 'election_number_of_alt_candidates',
    election_model: 'election_model',
    election_election_model: 'election_election_model',
    election_description: 'election_description',
    election_annual_description: 'election_annual_description',
    election_job_position_city: 'election_job_position_city',
    election_default_region: 'election_default_region',
    election_s_lag_description: 'election_s_lag_description',
    election_how_to_vote_description: 'election_how_to_vote_description',
};

export const electionAttributeNumberKeys = Object.values(ELECTION_ATTRIBUTE_NUMBERS);
